/* Only background video controls. No form, pricing, lead capture or cart access. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('.hero').forEach(function (hero) {
      var video = hero.querySelector('.hg-hero-film');
      var toggle = hero.querySelector('[data-hg-video-toggle]');
      if (!video || !toggle || toggle.dataset.ready) return;
      toggle.dataset.ready = 'true';
      toggle.hidden = false;
      function sync() {
        toggle.textContent = video.paused ? 'Play video' : 'Pause video';
        toggle.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
      }
      toggle.addEventListener('click', function () {
        if (video.paused) video.play().catch(sync); else video.pause();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', function () { toggle.hidden = true; video.hidden = true; });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(sync);
      sync();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
